import * as angular from 'angular';

import firebase from 'firebase/app';
import 'firebase/messaging';

(function () {
    'use strict';

    angular.module('ng').run([
        '$templateCache',
        function ($templateCache) {
            $templateCache.put(
                'dataProcessingDialog',
                require('!raw-loader!./components/auth/agreements_dialogs/data_processing_dialog/data_processing_dialog.html')
            );
            $templateCache.put(
                'termsDialog',
                require('!raw-loader!./components/auth/agreements_dialogs/terms_dialog/terms_dialog.html')
            );

            $templateCache.put(
                'bulkChangeStatusDialog',
                require('!raw-loader!./components/issues/company_issue_list/bulk_actions/change-status/change-status.dialog.html')
            );

            $templateCache.put(
                'addFilesDialog',
                require('!raw-loader!./components/issues/company_issue_list/details/add_files_dialog/add_files.dialog.html')
            );
            $templateCache.put(
                'changeAdditionalPersonalDataDialog',
                require('!raw-loader!./components/issues/company_issue_list/details/change-additional-personal-data/change-additional-personal-data.dialog.html')
            );
            $templateCache.put(
                'changeCategoryDialog',
                require('!raw-loader!./components/issues/company_issue_list/details/change-category/change-category.dialog.html')
            );
            $templateCache.put(
                'changeClientDialog',
                require('!raw-loader!./components/issues/company_issue_list/details/change-client-dialog/change-client.dialog.html')
            );
            $templateCache.put(
                'changeContractorDialog',
                require('!raw-loader!./components/issues/company_issue_list/details/change-contractor-dialog/change-contractor.dialog.html')
            );
            $templateCache.put(
                'changeCostsDialog',
                require('!raw-loader!./components/issues/company_issue_list/details/change-costs/change-costs.dialog.html')
            );
            $templateCache.put(
                'changeIdDialog',
                require('!raw-loader!./components/issues/company_issue_list/details/change-id/change-id.dialog.html')
            );
            $templateCache.put(
                'changeStatusDialog',
                require('!raw-loader!./components/issues/company_issue_list/details/change_status_dialog/change_status.dialog.html')
            );
            $templateCache.put(
                'customFieldsDialog',
                require('!raw-loader!./components/issues/company_issue_list/details/custom-fields/custom-fields.dialog.html')
            );
            $templateCache.put(
                'deleteDialog',
                require('!raw-loader!./components/delete_dialog/delete.dialog.html')
            );
            $templateCache.put(
                'editDescriptionDialog',
                require('!raw-loader!./components/issues/company_issue_list/details/edit-description/edit-description.dialog.html')
            );
            $templateCache.put(
                'revenueDialog',
                require('!raw-loader!./components/issues/company_issue_list/details/revenue/revenue.dialog.html')
            );
            $templateCache.put(
                'termDialog',
                require('!raw-loader!./components/issues/company_issue_list/details/term_dialog/term.dialog.html')
            );
            $templateCache.put(
                'issueLocationsDialog',
                require('!raw-loader!./components/issues/company_issue_list/details/issue-locations-dialog/issue-locations.dialog.html')
            );

            $templateCache.put(
                'selectorOfVariant',
                require('!raw-loader!./components/periodic_tasks/repeater_configurator/selector_of_variant.html')
            );
            $templateCache.put(
                'selectorOfWhichWhat',
                require('!raw-loader!./components/periodic_tasks/repeater_configurator/selector_of_which_what.html')
            );
            $templateCache.put(
                'selectorOfMonths',
                require('!raw-loader!./components/periodic_tasks/repeater_configurator/selector_of_months.html')
            );
            $templateCache.put(
                'selectorOfDaysOfWeek',
                require('!raw-loader!./components/periodic_tasks/repeater_configurator/selector_of_days_of_week.html')
            );
            $templateCache.put(
                'selectorOfDaysOfMonth',
                require('!raw-loader!./components/periodic_tasks/repeater_configurator/selector_of_days_of_month.html')
            );

            $templateCache.put(
                'displayFrequency',
                require('!raw-loader!./components/periodic_tasks/task_details/display_frequency.html')
            );
            $templateCache.put(
                'displayWhichWhat',
                require('!raw-loader!./components/periodic_tasks/task_details/display_which_what.html')
            );
            $templateCache.put(
                'displayMonths',
                require('!raw-loader!./components/periodic_tasks/task_details/display_months.html')
            );
            $templateCache.put(
                'displayDaysOfWeek',
                require('!raw-loader!./components/periodic_tasks/task_details/display_days_of_week.html')
            );
            $templateCache.put(
                'displayDaysOfMonth',
                require('!raw-loader!./components/periodic_tasks/task_details/display_days_of_month.html')
            );

            $templateCache.put(
                'haIssueFormDialog',
                require('!raw-loader!./components/issues/issue_forms/ha_form/ha_issue_form.dialog.html')
            );

            $templateCache.put(
                'paginationUniversalScript',
                require('!raw-loader!./partials/universal_scripts/partials/pagination/pagination.html')
            );
        },
    ]);
    angular.module('app').run(runBlock);

    /** @ngInject */
    function runBlock(
        $location,
        $rootScope,
        $state,
        $stateParams,
        LocalStorageService,
        AuthFactory,
        ServerMessageService
    ) {
        init();

        function init() {
            $rootScope.$state = $state;
            $rootScope.$stateParams = $stateParams;
            handleImpersonatedSession();
            checkUserGroupAndForwardHim();
            initializeFirebase();
            ServerMessageService.init();
        }

        function handleImpersonatedSession() {
            const token = document.cookie
                .split('; ')
                .find((row) =>
                    row.startsWith('startImpersonatedSessionWithToken=')
                )
                ?.split('=')[1];
            if (!token) {
                return;
            }
            // clear cookie
            document.cookie =
                'startImpersonatedSessionWithToken=; domain=.iwykonawca.pl; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
            LocalStorageService.removeLocalData();
            LocalStorageService.set('common/token', 'Bearer ' + token);
            $state.go('login');
        }

        function checkUserGroupAndForwardHim() {
            if (
                LocalStorageService.getObject('common/user') &&
                ($location.path() === '/logowanie' || $location.path() === '/')
            ) {
                var user = LocalStorageService.getObject('common/user');
                var query = $location.search();
                if (query['next']) {
                    AuthFactory.readMe().then(function () {
                        window.location.href = query['next'];
                    });
                    return;
                }
                switch (user.groups[0]) {
                    case 'CompanyEmployee':
                        $location.path('/panel-firmy/biezace-awarie');
                        break;
                    case 'HousingAssociationEmployee':
                        $location.path('/panel-klienta/zgloszenia');
                        break;
                    default:
                        $location.path('/panel-administracyjny');
                }
            }
        }

        function initializeFirebase() {
            var config = {
                apiKey: 'AIzaSyDGki_p8bmy0Vb7HJUNcgOjNoABlPXgflM',
                authDomain: 'imieszkaniec.firebaseapp.com',
                databaseURL: 'https://imieszkaniec.firebaseio.com',
                projectId: 'imieszkaniec',
                storageBucket: 'imieszkaniec.appspot.com',
                messagingSenderId: '954957455089',
                appId: '1:954957455089:web:6562ba867775cefcfa9350',
            };
            firebase.initializeApp(config);
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/index.run.ts